import { render, staticRenderFns } from "./SectionAbout.vue?vue&type=template&id=4d1d7b38&scoped=true"
var script = {}
import style0 from "./SectionAbout.vue?vue&type=style&index=0&id=4d1d7b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d7b38",
  null
  
)

export default component.exports